import { render, staticRenderFns } from "./ProfileSpeedboatContact.vue?vue&type=template&id=0b45836c"
import script from "./ProfileSpeedboatContact.vue?vue&type=script&lang=js"
export * from "./ProfileSpeedboatContact.vue?vue&type=script&lang=js"
import style0 from "./ProfileSpeedboatContact.vue?vue&type=style&index=0&id=0b45836c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports